module.exports = __webpack_public_path__ + "img/flv.ee9379d.svg";